<mpro-modal  [class.freemiumIntroduction]="!callbackRequested" [class.thankYou]="callbackRequested" *ngIf="isModalOpen && isFreemium" [(open)]="isModalOpen" (openChange)="closeModal()">
    <main class="container-sm" *ngIf="!callbackRequested; else thankYouModal">
      <section class="row" *ngIf="currentStep === 1">
        <div class="col-12">
          <h2>At World Data Lab we create proprietary forward-looking data on consumer spending to quantify addressable markets and growth trajectories</h2>
          <img src="/assets/Frame21322.png"/>
        </div>
      </section>
      <section class="row" *ngIf="currentStep === 2">
        <div class="col-12 d-flex justify-content-center"> 
          <div>
            <h2>Our data is updated 4 times a year and<br/> is always available on World Data Pro</h2>
            <img class="mx-auto d-block" src="/assets/calendar.png"/> 
          </div>
        </div>
      </section>
      <section class="row justify-content-center" *ngIf="currentStep === 3">
        <div class="col-10 my-4">
          <div class="row">
            <div class="col-4 text-left">
              <h2 class="text-left my-0">As a freemium user, you will have free access to:</h2>
            </div>
            <div class="col-4 align-self-center">
              <img class="my-4 w-100" src="/assets/Consumer-Spending.png" />
            </div>
            <div class="col-4 align-self-end text-right">
              <img src="/assets/check-circle.png" />
              <h2 class="my-0">Total population and demand data</h2>
            </div>
          </div>
        </div>
      </section>
      <section class="row justify-content-center" *ngIf="currentStep === 4">
        <div class="col-10 my-4">
          <div class="row">
            <div class="col-4 text-left">
              <h2 class="text-left my-0">As a freemium user, you will have free access to:</h2>
            </div>
            <div class="col-4 align-self-center">
              <img class="my-4 w-100" src="/assets/Frame21336.png" />
            </div>
            <div class="col-4 align-self-end text-right">
              <img src="/assets/check-circle.png" />
              <h2 class="my-0">Demand data broken down by one of WDL’s 12 macro categories</h2>
            </div>
          </div>
        </div>
      </section>
      <section class="row justify-content-center" *ngIf="currentStep === 5">
        <div class="col-10 my-4">
          <div class="row">
            <div class="col-4 text-left d-flex align-items-end flex-column">
              <h2 class="text-left my-0">As a freemium user, you will have free access to:</h2>
              <div class="mt-auto">
                <img src="/assets/check-circle.png" />
                <h2 class="my-0">Continent level geographical breakdowns</h2>
              </div>
            </div>
            <div class="col-8 align-self-center">
              <img class="w-100" src="/assets/Map.png" />
            </div>
          </div>
        </div>
      </section>
      <section class="row justify-content-center" *ngIf="currentStep === 6">
        <div class="col-10 my-4">
          <div class="row">
            <div class="col-4 text-left">
              <h2 class="text-left my-0">As a freemium user, you will have free access to:</h2>
            </div>
          </div>
          <div class="row justify-content-end">
            <div class="col-6 align-self-center">
              <img class="my-4 w-100" src="/assets/Frame21337.png" />
            </div>
            <div class="col-3 align-self-end text-right">
              <img src="/assets/check-circle.png" />
              <h2 class="my-0">All age and spending demographic groupings</h2>
            </div>
          </div>
        </div>
      </section>
      
      <section class="row justify-content-center" *ngIf="currentStep === 7">
        <div class="col-10 my-4">
          <div class="row mb-4">
            <div class="col-4 text-left">
              <h2 class="text-left my-0">As a freemium user, you will have free access to:</h2>
            </div>
          </div>
          <div class="row justify-content-end">
            <div class="col-12 my-4 text-center">
              <img class="my-4 mx-auto" src="/assets/Frame21338.png" />
            </div>
          </div>
          <div class="row justify-content-end">
            <div class="col-3 align-self-end text-right">
              <img src="/assets/check-circle.png" />
              <h2 class="my-0">2024, 2025,<br/> 2030 and 2034 forecasts</h2>
            </div>
          </div>
        </div>
      </section>
      <section class="row" *ngIf="currentStep === 8">
        <div class="col-5 mt-5">
          <h2 class="text-left mt-5">If you would like to speak with us about access to greater data depth by countries, cities, categories or demographics please just press the 'call me back' button and we will aim to be in touch within 48 hours.</h2>
          <button class="mpro-btn mpro-btn-primary" (click)="requestCallback()">CALL ME BACK</button>
        </div>
        <div class="col-lg-7 relative">
          <img src="/assets/laptop-png.png" id="laptop" />
        </div>
      </section>
      <section class="row paginationContainer" *ngIf="displaySteps">
        <div class="col-12">   
          <button *ngIf="currentStep !== 1" class="buttonPreviousSlide" (click)="changeStep(false)">
            <fa-icon [icon]="faChevronLeft"></fa-icon>
          </button>
          <div class="pagination">
            <span *ngFor="let step of steps" class="dot" [class.previous]="step < currentStep" [class.next]="step > currentStep" [class.active]="step === currentStep" [attr.data-page]="step"></span>
            <span class="pill" [attr.data-page]="currentStep"></span>
          </div>
          <button *ngIf="currentStep !== steps.length + 1" class="buttonNextSlide" (click)="changeStep(true)">
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </button>
        </div>
      </section>
    </main>
    <ng-template #thankYouModal>
      <main>
        <div class="thank-you-msg">
          <h2>Thank you!</h2>
          <p class="align-center">Thank you for contacting us! We will get back to you as soon as we review your request.</p>
          <button id="big-button" class="active" (click)="closeModal()">Back to world data pro</button>
        </div>
      </main>
      <mpro-curve-background-animation></mpro-curve-background-animation>
    </ng-template>
</mpro-modal>
